export const marketStatuses: Record<number, string> = {
  1: "Inactive",
  2: "Open",
  3: "Suspended",
  4: "Closed",
};
